import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-computer-science',
  templateUrl: './computer-science.component.html',
  styleUrls: ['./computer-science.component.scss']
})
export class ComputerScienceComponent implements OnInit {
  computer:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.computer=this.facultyService.getComputer();
  }

}
